const ReactDropDown = props => {
  const dropDown = React.useRef(null);
  const [display, setDisplay] = React.useState("none");
  const dropDownSwitch = () => {
    display == "none" ? setDisplay("grid") : setDisplay("none");
  };
  const closeropDown = e => {
    if (dropDown.current && !dropDown.current.contains(e.target)) {
      setDisplay("none");
    }
  };
  React.useEffect(() => {
    document.addEventListener('mousedown', closeropDown);
    return () => {
      window.removeEventListener('mousedown', closeropDown);
    };
  }, [display]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    ref: dropDown,
    className: "dropdown",
    style: {
      position: "relative"
    }
  }, /*#__PURE__*/React.createElement("button", {
    className: "dropdownButton",
    onClick: dropDownSwitch
  }, props.header, /*#__PURE__*/React.createElement("img", {
    className: "dropdownButtonArrow",
    alt: "Arrow down",
    height: "10px",
    width: "10px",
    src: "https://cdn.shopify.com/s/files/1/2665/0346/files/arrowDownNew.svg?v=1683641051"
  })), /*#__PURE__*/React.createElement("div", {
    style: {
      display: display
    }
  }, props.children)));
};
